(function ($){
    $.noConflict();
    $(document).ready(function () {

        $(".header__icon--menu").click(function(){
            $("body").toggleClass("locked");
        });
        $("#menu-drawer ul li.dropdown-item").click(function(e){
            $(this).find(".dropdown-item-menu").slideToggle();
            $(this).toggleClass("active");
        });
        $("#menu-drawer ul li:has(ul), .slide-panel-inner-container ul li:has(ul)").addClass('subbed');
        $(".dropdown-item-menu li, .slide-panel-inner-container li.slide-panel-nav-child-item").click(function(e){
            $(this).find("ul.navigation-grand-child").slideToggle();
            $(this).find("span").toggleClass("open");
            e.stopPropagation();
        });

        // Slideout Menu
        function slideoutMenu(){
            // Slideout Open
            $('.site-header__slideout-menu').click(function (){
                $('.slideout-menu').show("slide", { direction: "left" }, 500);
            });
            // Slideout Items
            $('.slideout-item').each(function (){
                if ($(this).find(".navigation-child").children().length > 0) {
                    $(this).addClass("slideout-active");
                }
            });
            // Slideout Item Active
            $(".slideout-active").click(function() {
                $(this).find(".slideout-top-item").toggleClass("open");
                $(this).find(".navigation-child").slideToggle();
                $(this).find(".slideout-down-arrow").toggleClass("rotate");
            });
            // Slideout Close
            $('.slideout-menu-close').click(function (){
                $('.slideout-menu').hide("slide", { direction: "left" }, 500);
                $(".slideout-top-item").removeClass("open");
                $(".navigation-child").hide();
                $(".slideout-down-arrow").removeClass("rotate");
            });
        }  

        slideoutMenu();

        // Mega Menu
        function megaMenu(){
            $('ul.header__submenu').each(function (){
                if ($(this).children().length > 5) {
                    $(this).addClass("plus");
                } else {
                    $(this).removeClass("plus");
                }
            });

            $("li.mega-menu-item").each(function(){
                if ($(this, "ul.header__submenu").find("li").length == 0 ){
                    $(this).addClass("blank");
                }
            });
        }
        
        megaMenu();

        // Slide-Panel-Menu
        function slidePanelMenu(){
            $('ul li.slide-panel-nav-main-item:has(ul)').addClass('has-menu');

            $('.site-header__slideout-menu, .slide-panel-nav-main-item i').click(function(){
                $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar').addClass('active');
            });

            $('li.slide-panel-nav-main-item').click(function(){
                $("ul.navigation-child", this).slideToggle();
                $(this).toggleClass('active');
            });

            $('.slide-panel-close').click(function(){
                $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar, li.slide-panel-nav-main-item').removeClass('active');
                $("ul.navigation-child").css("display", "none");
            });
        }

        slidePanelMenu();

        // Rerun Scripts in Shopify Theme Editor
        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function(){
                slideoutMenu();
                megaMenu();
                slidePanelMenu();
            });
        }

    });
})(jQuery);